import React from "react";
import { useSelector } from "react-redux";
import { Button, Modal } from "@accessdev/arc-ui-react";
import { selectors } from "@ReduxStore/reducers";

import "./SessionExpired.scss";
import { Trans } from "@lingui/react/macro";

export default function SessionExpired() {
  const isSessionExpired = useSelector(selectors.getIsSessionExpired);

  if (!isSessionExpired) return null;

  return (
    <Modal>
      <div className="session-expired_wrapper">
        <h1 className="session-expired_title">
          <Trans>It appears your session has expired.</Trans>
        </h1>
        <p>
          <Trans>Please refresh the page to get back</Trans>
          <br />
          <Trans>to our amazing deals!</Trans>
        </p>
        <Button
          className="session-expired_button"
          onClick={() => {
            window.location.reload();
          }}
        >
          <Trans>Restart Session</Trans>
        </Button>
      </div>
    </Modal>
  );
}
